import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Piles from "./pages/Piles";
import Fistula from "./pages/Fistula"
import Fissure from "./pages/Fissure"
import Pilonidal from "./pages/Pilonidal"
import Rectal from "./pages/Rectal"
import Hernia from "./pages/Hernia"
import Gallstones from "./pages/Gallstones"
import Appendicitis from "./pages/Appendicitis"
import Inguinal from "./pages/Inguinal"
import Umbilical from "./pages/Umbilical"
import Surgical from "./pages/Surgical"
import MTP from "./pages/MTP"
import Ectopic from "./pages/Ectopic"
import Molar from "./pages/Molar"
import Uterus from "./pages/Uterus"
import Ovarian from "./pages/Ovarian"
import Miscarriage from "./pages/Miscarriage"
import Bartholin from "./pages/Bartholin"
import Endometriosis from "./pages/Endometriosis"
import Adenomyosis from "./pages/Adenomyosis"
import PCOSPCOD from "./pages/PCOS-PCOD"
import Pregnancy from "./pages/Pregnancy"
import Laser from "./pages/Laser"
import Hymenoplasty from "./pages/Hymenoplasty"
import Vaginoplasty from "./pages/Vaginoplasty"
import Labiaplasty from "./pages/Labiaplasty"
import Vaginal from "./pages/Vaginal"
import Varicose from "./pages/Varicose"
import Varicocele from "./pages/Varicocele"
import DVT from "./pages/DVT"
import Diabetic from "./pages/Diabetic"
import Uterine from "./pages/Uterine"
import AVFistula from "./pages/AVFistula"
import Gynecomastia from "./pages/Gynecomastia"
import Liposuction from "./pages/Liposuction"
import Lipoma from "./pages/Lipoma"
import Breast from "./pages/Breast"
import Sebaceous from "./pages/Sebaceous"
import Rhinoplasty from "./pages/Rhinoplasty"
import BreastAugmentation from "./pages/BreastAugmentation"
import Axillary from "./pages/Axillary"
import TummyTuck from "./pages/TummyTuck"
import BreastLump from "./pages/BreastLump"
import BreastReduction from "./pages/BreastReduction"
import ScarRemoval from "./pages/ScarRemoval"
import DoubleChin from "./pages/DoubleChin"
import BuccalFat from "./pages/BuccalFat"
import EarlobeRepair from "./pages/EarlobeRepair"
import Blepharoplasty from "./pages/Blepharoplasty"
import BeardTransplant from "./pages/BeardTransplant"
import CleftLip from "./pages/CleftLip"
import HairFallPRP from "./pages/HairFallPRP"
import KneeReplacement from "./pages/KneeReplacement"
import CarpalTunnelSyndrome from "./pages/CarpalTunnelSyndrome"
import ACLTearTreatment from "./pages/ACLTearTreatment"
import MeniscusTearTreatment from "./pages/MeniscusTearTreatment"
import HipReplacementSurgery from "./pages/HipReplacementSurgery"
import SpineSurgery from "./pages/SpineSurgery"


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/Piles" element={<Piles />} />
      <Route path="/Fistula" element={<Fistula />} />
      <Route path="/Fissure" element={<Fissure />} />
      <Route path="/Pilonidal" element={<Pilonidal />} />
      <Route path="/Rectal" element={<Rectal />} />
      <Route path="/Hernia" element={<Hernia />} />
      <Route path="/Gallstones" element={<Gallstones />} />
      <Route path="/Appendicitis" element={<Appendicitis />} />
      <Route path="/Inguinal" element={<Inguinal />} />
      <Route path="/Umbilical" element={<Umbilical />} />
      <Route path="/Surgical" element={<Surgical />} />
      <Route path="/MTP" element={<MTP />} />
      <Route path="/Ectopic" element={<Ectopic />} />
      <Route path="/Molar" element={<Molar />} />
      <Route path="/Uterus" element={<Uterus />} />
      <Route path="/Ovarian" element={<Ovarian />} />
      <Route path="/Miscarriage" element={<Miscarriage />} />
      <Route path="/Bartholin" element={<Bartholin />} />
      <Route path="/Endometriosis" element={<Endometriosis />} />
       <Route path="/Adenomyosis" element={<Adenomyosis />} />
       <Route path="/PCOS-PCOD" element={<PCOSPCOD />} />
       <Route path="/Pregnancy" element={<Pregnancy />} />
       <Route path="/Laser" element={<Laser />} />
      <Route path="/Hymenoplasty" element={<Hymenoplasty />} />
      <Route path="/Vaginoplasty" element={<Vaginoplasty />} />
      <Route path="/Labiaplasty" element={<Labiaplasty />} />
      <Route path="/Vaginal" element={<Vaginal />} />
      <Route path="/Varicose" element={<Varicose />} />
      <Route path="/Varicocele" element={<Varicocele />} />
      <Route path="/DVT" element={<DVT />} />
      <Route path="/Diabetic" element={<Diabetic />} />
      <Route path="/Uterine" element={<Uterine />} />
      <Route path="/AVFistula" element={<AVFistula />} />
      <Route path="/Gynecomastia" element={<Gynecomastia />} />
      <Route path="/Liposuction" element={<Liposuction />} />
      <Route path="/Lipoma" element={<Lipoma />} />
      <Route path="/Breast" element={<Breast />} />
       <Route path="/Adenomyosis" element={<Adenomyosis />} />
       <Route path="/PCOS-PCOD" element={<PCOSPCOD />} />
       <Route path="/Sebaceous" element={<Sebaceous />} />
       <Route path="/Rhinoplasty" element={<Rhinoplasty />} />
       <Route path="/BreastAugmentation" element={<BreastAugmentation />} />
       <Route path="/Axillary" element={<Axillary />} />
      <Route path="/TummyTuck" element={<TummyTuck />} />
      <Route path="/BreastLump" element={<BreastLump />} />
      <Route path="/BreastReduction" element={<BreastReduction />} />
      <Route path="/ScarRemoval" element={<ScarRemoval />} />
      <Route path="/DoubleChin" element={<DoubleChin />} />
      <Route path="/BuccalFat" element={<BuccalFat />} />
       <Route path="/EarlobeRepair" element={<EarlobeRepair />} />
       <Route path="/Blepharoplasty" element={<Blepharoplasty />} />
       <Route path="/BeardTransplant" element={<BeardTransplant />} />
       <Route path="/CleftLip" element={<CleftLip />} />
       <Route path="/HairFallPRP" element={<HairFallPRP />} />
        <Route path="/KneeReplacement" element={<KneeReplacement />} />
       <Route path="/CarpalTunnelSyndrome" element={<CarpalTunnelSyndrome />} />
       <Route path="/ACLTearTreatment" element={<ACLTearTreatment />} />
       <Route path="/MeniscusTearTreatment" element={<MeniscusTearTreatment />} />
       <Route path="/HipReplacementSurgery" element={<HipReplacementSurgery />} />
       <Route path="/SpineSurgery" element={<SpineSurgery />} />
    </Routes>
  </BrowserRouter>
);
